export default class ClinicalInformations {
  constructor({
    nearestSite, otherSites,
  } = {}) {
    this.nearestSite = nearestSite;
    this.otherSites = otherSites;
  }

  hasInformations() {
    return !!this.nearestSite || !!this.otherSites;
  }

  getNearestSite() {
    return this.nearestSite || {};
  }

  hasNearestSite() {
    return Object.keys(this.getNearestSite()).length;
  }

  getOtherSites() {
    return this.otherSites || [];
  }
}
